import React, { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Brain, TrendingUp, Sparkles, Loader2, Calendar } from "lucide-react";
import authService from "../../services/authService";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/ia-global`;

const IAGlobalDashboard = () => {
  const [carregando, setCarregando] = useState(true);
  const [topOportunidades, setTopOportunidades] = useState([]);
  const [calendario, setCalendario] = useState([]);
  const [dashboard, setDashboard] = useState(null);

  const carregar = async () => {
    setCarregando(true);
    try {
      const [respTop, respCal, respDash] = await Promise.all([
        authService.fetchAuth(`${API}/scores/top?limit=10`),
        authService.fetchAuth(`${API}/conteudo/calendario`),
        authService.fetchAuth(`${API}/dashboard`),
      ]);
      if (respTop.ok) setTopOportunidades(await respTop.json());
      if (respCal.ok) setCalendario((await respCal.json()).calendario || []);
      if (respDash.ok) setDashboard(await respDash.json());
    } catch (error) {
      console.error("Erro ao carregar IA Global:", error);
    } finally {
      setCarregando(false);
    }
  };

  useEffect(() => {
    carregar();
  }, []);

  if (carregando) {
    return (
      <div className="flex items-center justify-center h-96 text-muted-foreground">
        <Loader2 className="w-6 h-6 animate-spin mr-2" />
        Carregando IA Global...
      </div>
    );
  }

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <div className="flex items-center gap-3 mb-6">
        <Brain className="w-7 h-7 text-purple-600" />
        <div>
          <h1 className="text-2xl font-bold">IA Global</h1>
          <p className="text-sm text-muted-foreground">Score de oportunidade e recomendações baseadas em dado real</p>
        </div>
      </div>

      {dashboard && !dashboard.provedor_ia_configurado && (
        <Card className="p-4 mb-6 bg-yellow-50 border-yellow-300">
          <p className="text-sm text-yellow-800">
            ℹ️ {dashboard.nota}
          </p>
        </Card>
      )}

      <Card className="p-5 mb-6">
        <h2 className="font-semibold mb-4 flex items-center gap-2">
          <TrendingUp className="w-5 h-5 text-green-600" />
          Top Oportunidades (calculado por margem, vendas e estoque)
        </h2>
        <div className="space-y-2">
          {topOportunidades.length === 0 && (
            <p className="text-sm text-muted-foreground text-center py-4">Nenhum produto com dados suficientes ainda.</p>
          )}
          {topOportunidades.map((p, i) => (
            <div key={p.produto_id} className="flex items-center justify-between p-3 border rounded-lg">
              <div className="flex items-center gap-3">
                <span className="text-lg font-bold text-muted-foreground">#{i + 1}</span>
                <p className="font-medium">{p.produto_nome}</p>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-24 bg-muted rounded-full h-2">
                  <div className="bg-green-500 h-2 rounded-full" style={{ width: `${p.score}%` }} />
                </div>
                <span className="text-sm font-bold">{p.score}</span>
              </div>
            </div>
          ))}
        </div>
      </Card>

      <Card className="p-5">
        <h2 className="font-semibold mb-4 flex items-center gap-2">
          <Calendar className="w-5 h-5 text-blue-600" />
          Calendário Sugerido de Postagens
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {calendario.map((c, i) => (
            <div key={i} className="p-3 border rounded-lg">
              <p className="text-sm font-bold">{c.dia} - {c.horario}</p>
              <p className="text-sm text-muted-foreground">{c.sugestao}</p>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default IAGlobalDashboard;
